import { render, staticRenderFns } from "./HeaderCollapseMenu.vue?vue&type=template&id=25b91d52&"
import script from "./HeaderCollapseMenu.vue?vue&type=script&lang=js&"
export * from "./HeaderCollapseMenu.vue?vue&type=script&lang=js&"
import style0 from "./HeaderCollapseMenu.vue?vue&type=style&index=0&id=25b91d52&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports